//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "NsLoyaltyInformation",
  props: {
    marketAttributes: {
      type: Object,
      default() {
        return {};
      }
    },
    productDetail: {
      type: Boolean,
      default: false
    },
    loyaltyStatusAndLinks: {
      type: Object,
      default() {
        return {};
      }
    },
    sku: {
      type: String,
      default: ""
    },
    isLoggedIn: Boolean,
    isOptedIn: Boolean,
    translations: {
      type: Object,
      default() {
        return {};
      }
    },
    userLoyalty: {
      type: Object,
      default() {
        return {};
      }
    },
    featureFlags: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {
    coinUrl() {
      if (
        this.isLoggedIn &&
        this.isOptedIn &&
        (!this.marketAttributes.earn || !this.marketAttributes.redeem)
      ) {
        return "/content/dam/apps/loyalty/global/loyalty_coin_green.svg";
      } else {
        return "/content/dam/apps/loyalty/global/loyalty_coin_blue.svg";
      }
    },
    dashboardLinkMessage() {
      if (this.marketAttributes.earn && this.marketAttributes.redeem) {
        return this.loyaltyStatusAndLinks.productOptedInEarnAndRedeem;
      } else if (this.marketAttributes.earn) {
        return this.loyaltyStatusAndLinks.productOptedInEarnNotRedeem;
      } else {
        return this.loyaltyStatusAndLinks.productOptedInRedeemNotEarn;
      }
    }
  }
};
